import { render, staticRenderFns } from "./ReportRadar.vue?vue&type=template&id=c447d544&"
import script from "./ReportRadar.vue?vue&type=script&lang=js&"
export * from "./ReportRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports